export const EVENTS = {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	KSYS_APP_LOADED: 'ksys-app-loaded',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	KSYS_APPS_LOADED: 'ksys-apps-loaded',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	KSYS_APP_EMBED_ADDED: 'ksys-app-embed-added',
};
